import { Client } from '@termly-web/common'


export default {
  ...Client,
  defaults: {
    ...Client.defaults,
    baseURL: `${ process.env.DOMAIN }/api`,
  },
}
